<div class="page-layout-container">
  <div class="row">
    <h1 class="title">Monthly Mobility Batch Update</h1>
  </div>

  <div *ngIf="message" class="alert alert-success">{{ messageDesc }}</div>
  <div *ngIf="error" class="alert alert-danger">{{ errorDesc }}</div>
  <div class="row">
    <div class="col-3" style="width: 100%">
      <mat-form-field>
        <mat-label>Generating Mobility for Current Month</mat-label>
        <input
          matInput
          [matDatepicker]="batchMonth"
          required
          [(ngModel)]="selectedMonth"
          (dateChange)="fetchMobilityStatus($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="batchMonth"
        ></mat-datepicker-toggle>
        <mat-datepicker #batchMonth></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-auto" style="text-align: center">
      <button
        mat-button
        [disabled]="isYearButtonDisabled"
        id="yearButton"
        (click)="updateMobilityForCurrentMonth()"
        type="submit"
      >
        Copy from Previous month
      </button>
    </div>
  </div>

  <div *ngIf="batchResult" class="row mt-4">
    <div class="col-12">
      <h2>Batch Job Details</h2>
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Batch Job Name</th>
            <th>Execution Date</th>
            <th>Status</th>
            <th>Batch Year</th>
            <th>Batch Month</th>
            <th>Triggered By</th>
            <th>Comments</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ batchResult.batchJobName }}</td>
            <td>{{ batchResult.executionDate }}</td>
            <td>{{ batchResult.status }}</td>
            <td>{{ batchResult.batchYear }}</td>
            <td>{{ batchResult.batchMonth }}</td>
            <td>{{ batchResult.batchTriggeredBy }}</td>
            <td>{{ batchResult.comments || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-progress [loading$]="loading$"> </app-progress>
</div>
